import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import SDVModal from "../SDV_VerificationModal/SDV_VerificationModal.vue";
import ListSdvQueryModal from "../ListSdvQueryModal/ListSdvQueryModal.vue";

export default {
    name: "sdvSummary",
    components: {
        VPagination,
        SDVModal,
        ListSdvQueryModal
    },
    props: {},
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            idToken: store.getters.getIdToken,
            showBlock: [true, false],
            defaultdate: "",
            defaultTime: "",
            headerValues: {},
            showTableLoading: false,
            sdvList: { Data: [], Total: 0 },
            formSdvList: { entities: [], totalCount: 0 },
            totalPage: 1,
            currentPage: 1,
            searchData: {
                PageNumber: 1,
                PageSize: 10,
                SortBy: "CreatedAt",
                SortOrder: "desc",
                Source: "",
                Status: "",
                FromDate: null,
                ToDate: null,
            },
            sdv: {
            },
            showSDVModal: false,
            showQueryModal: false,
            selectedId: "",
            selectedDataRef: [],
            selectedModalType: "",
            selectedFromTab:""
        };
    },
    async mounted() {
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        this.defaultdate = localStorage.getItem("dateformat");
        this.defaultTime = localStorage.getItem("timeformat"),
        window.addEventListener("studyIdChanged", async () => {
              this.studyId = store.getters.getStudyIs
              await this.getSDVList();
              await this.getFormSDVList();
            });
        this.studyId = store.getters.getStudyIs
        await this.getSDVList();
        await this.getFormSDVList();
    },
    methods: {
        activatedtab(){
            if(this.showBlock[0] == true){
                return "activeTab"
            } 
            else{
                 return "inactive";
            }
        },
        async selectDataSignalTab() {
            this.showBlock[0] = true;
            this.showBlock[1] = false;
            this.searchData.PageNumber = 1;
            await this.getSDVList();
        },
 
        async selectFormSdvTab() {
            this.showBlock[1] = true;
            this.showBlock[0] = false;
            this.searchData.PageNumber = 1;
            await this.getFormSDVList();
        },
        async getSDVList() {
            this.showTableLoading = true;
            try {
                let url = `${this.baseurl}/stats-python/formstatistics/getallsdv`
                    + `?PageNumber=${this.searchData.PageNumber}`
                    + `&PageSize=${this.searchData.PageSize}`
                    + `&SortBy=CreatedAt`
                    + `&SortOrder=desc`
                    + `&StudyId=${this.studyId}`
                    + `&Source=${this.searchData.Source || ""}`
                    + `&Status=${this.searchData.Status || ""}`;
                
                if (this.searchData.FromDate) {
                    url += `&FromDate=${this.searchData.FromDate}`;
                }
                if (this.searchData.ToDate) {
                    url += `&ToDate=${this.searchData.ToDate}`;
                }

                const res = await axios.get(url, this.headerValues);
                this.showTableLoading = false;
                console.log("SDV List Response:", res.data);
                this.sdvList = res.data;
                this.totalPage = parseInt(this.sdvList.Total / this.searchData.PageSize);
                if (this.searchData.PageSize % this.pagesize != 0) {
                    this.totalPage = this.totalPage + 1;
                }
            } catch (error) {
                this.showTableLoading = false;
                console.error("Error fetching SDV List:", error);

            }
        },
        async getFormSDVList() {
            this.showTableLoading = true;
            try {
                let url = `${this.baseurl}/forms/rbqm/getallformsdv`
                    + `?pageindex=${this.searchData.PageNumber}`
                    + `&pagesize=${this.searchData.PageSize}`
                    + `&SortProperty=CreatedAt`
                    + `&SortOrder=desc`
                    + `&studyid=${this.studyId}`
                    + `&source=${this.searchData.Source || ""}`
                    + `&status=${this.searchData.Status || ""}`;
                
                if (this.searchData.FromDate) {
                    url += `&assignedFrom=${this.searchData.FromDate}`;
                }
                if (this.searchData.ToDate) {
                    url += `&assignedTo=${this.searchData.ToDate}`;
                }

                const res = await axios.get(url, this.headerValues);
                this.showTableLoading = false;
                console.log("Form SDV List Response:", res.data);
                this.formSdvList = res.data;
                this.totalPage = parseInt(this.formSdvList.totalCount / this.searchData.PageSize);
                if (this.searchData.PageSize % this.pagesize != 0) {
                    this.totalPage = this.totalPage + 1;
                }
            } catch (error) {
                this.showTableLoading = false;
                console.error("Error fetching SDV List:", error);

            }
        },
        loadPage: function (page) {
            this.currentPage = page;
            this.searchData.PageNumber = page;
            if(this.showBlock[0] === true){
            this.getSDVList();
            }
            else{
                this.getFormSDVList();
            }
        },
        async search() {
            if(this.showBlock[0] === true){
            this.searchData.PageNumber = 1;
            await this.getSDVList();
            }
            else{
                await this.getFormSDVList();
            }
        },
        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate);
            }
        },
        filterDate(data) {
            if (!data) {
                return null;
            }
            return moment(data).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
        },
        async openSDVModal(id, modalType,fromTab){
            this.selectedId = id;
            this.selectedModalType = modalType;
            this.selectedFromTab = fromTab;
            this.showSDVModal = true;
        },
        Openquerypopup(sdvId) {
            this.showQueryModal = true;
            this.selectedId = sdvId;

        },
        Closequerypopup(){
            this.querypopup = false;
        },
        async closeSDVModal(){
            this.showSDVModal = false;
        },
        async closeQueryModal(){
            this.showQueryModal = false;
        }

    }
}

